<template>
  <div :class="{'page_content--loading': !reportData}">
    <div class="vx-row justify-end">
      <div class="vx-col">
        <DateRanges
          :start-day="startDay"
          :end-day="endDay"
          @on-change="onDateChange"
        />
      </div>
    </div>
    <div class="vx-row justify-end">
      <div class="vx-col">
        <switch-field
          v-model="innerFiltered"
          class="mt-4 mb-4"
          name="フィルター表示"
          label="フィルター表示"
        />
      </div>
    </div>
    <div
      v-if="showFilters"
      class="vx-row justify-end"
    >
      <div
        style="z-index: 9998;"
        class="vx-col"
      >
        <div class="filter">
          <sales-filter
            v-model="selectedTitles"
            class="w-48 mb-1 mr-1"
            :options="titleOptions"
            :no-option-text="salesByTitleFilterNoOptionText"
            placeholder="商品名"
          />
          <sales-filter
            v-model="selectedAsins"
            class="w-48 mb-1 mr-1"
            :options="asinOptions"
            :no-option-text="salesByAsinFilterNoOptionText"
            placeholder="ASIN"
          />
          <sales-filter
            v-model="selectedParentAsins"
            class="w-48 mb-1 mr-1"
            :options="parentAsinOptions"
            :no-option-text="salesByParentAsinFilterNoOptionText"
            placeholder="親ASIN"
          />
          <sales-filter
            v-model="selectedBrands"
            class="w-48 mb-1 mr-1"
            :options="brandOptions"
            :no-option-text="salesByBrandFilterNoOptionText"
            placeholder="ブランド"
          />
          <sales-filter
            v-model="selectedSubCategoryNames"
            class="w-48 mb-1"
            :options="subCategoryNameOptions"
            :no-option-text="salesBySubCategoryNameFilterNoOptionText"
            placeholder="サブカテゴリー名"
          />
        </div>
      </div>
      <div
        class="vx-col"
        style="z-index: 9997;"
      >
        <div class="filter">
          <sales-filter
            v-model="selectedSellerCategories"
            class="w-48 mb-1 mr-1"
            :options="sellerCategoryOptions"
            :no-option-text="salesBySellerCategoryFilterNoOptionText"
            placeholder="出品者カテゴリー1"
          />
          <sales-filter
            v-model="selectedSellerCategories2"
            class="w-48 mb-1 mr-1"
            :options="sellerCategory2Options"
            :no-option-text="salesBySellerCategory2FilterNoOptionText"
            placeholder="出品者カテゴリー2"
          />
          <sales-filter
            v-model="selectedSellerCategories3"
            class="w-48 mb-1 mr-1"
            :options="sellerCategory3Options"
            :no-option-text="salesBySellerCategory3FilterNoOptionText"
            placeholder="出品者カテゴリー3"
          />
          <sales-filter
            v-model="selectedSellerCategories4"
            class="w-48 mb-1 mr-1"
            :options="sellerCategory4Options"
            :no-option-text="salesBySellerCategory4FilterNoOptionText"
            placeholder="出品者カテゴリー4"
          />
          <sales-filter
            v-model="selectedSellerCategories5"
            class="w-48 mb-1"
            :options="sellerCategory5Options"
            :no-option-text="salesBySellerCategory5FilterNoOptionText"
            placeholder="出品者カテゴリー5"
          />
        </div>
      </div>
    </div>
    <div class="vx-row mt-4">
      <div class="vx-col w-1/4 pr-0 flex flex-col">
        <div class="flex flex-row flex-1">
          <score-card
            class="flex-1"
            title="売上"
            :score="reportData.summary?.sales"
            currency
          />
        </div>
      </div>
      <div class="vx-col w-1/4">
          <score-card
            class="flex-1"
            title="新規売上"
            :score="reportData.summary?.newSales"
            currency
          />
          <score-card
            class="flex-1 mt-4"
            title="リピート売上"
            :score="reportData.summary?.repeatSales"
            currency
          />
      </div>
      <div class="vx-col w-1/4 pr-0">
        <score-card
          class="flex-1"
          title="新規_通常売上"
          :score="reportData.summary?.newGeneralSales"
          currency
        />
        <score-card
          class="flex-1 mt-4"
          title="リピート_通常売上"
          :score="reportData.summary?.repeatGeneralSales"
          currency
        />
      </div>
      <div class="vx-col w-1/4">
        <score-card
          class="flex-1"
          title="新規_定期便売上"
          :score="reportData.summary?.newSnSSales"
          currency
        />
        <score-card
          class="flex-1 mt-4"
          title="リピート_定期便売上"
          :score="reportData.summary?.repeatSnSSales"
          currency
        />
      </div>
    </div>
    <div class="vx-row px-4 mt-8">
      <vx-card>
        <amc-repeat-chart
          :class="{'min-h-full': !reportData}"
          :report="reportData.pastYearMonthly"
          label-field="month"
          :height="400"
          :precision="2"
        />
      </vx-card>
    </div>
    <div
      v-if="reportData"
      class="mt-8"
    >
      <div class="">
        <vx-card>
          <data-table
            :column-defs="columnDefs"
            :default-col-def="defaultColDef"
            :pinned-bottom-row-data="pinnedBottomRowData"
            :row-data="reportData.selectedCategory"
            :getRowStyle="getRowStyle"
            :grid-options="gridOptions"
            pagination
            @update:current-page="onUpdateCurrentPage"
            @update:pagination-page-size="onUpdatePaginationPageSize"
            @sort-changed="onSortChange"
          >
            <template #actions>
              <vs-button
                @click="onClickDownload('selectedCategory')"
              >
                CSVエクスポート
              </vs-button>
            </template>
          </data-table>
        </vx-card>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import moment from 'moment'
import DataTable from '@/components/table/DataTable'
import DateRanges from '@/components/DateRanges'
import ScoreCard from '@/components/ScoreCard'
import SectionTitle from '@/components/SectionTitle'
import SalesFilter from '@/components/SalesFilter'
import AmcRepeatChart from '@/user/components/charts/AmcRepeatChart'
import SwitchField from '@/components/fields/SwitchField'
import { debounce } from '@/utils'

export default {
  components: {
    DataTable,
    DateRanges,
    ScoreCard,
    SalesFilter,
    SectionTitle,
    SwitchField,
    AmcRepeatChart
  },
  data () {
    return {
      // フィルター
      selectedAsins: [],
      selectedTitles: [],
      selectedBrands: [],
      selectedSubCategoryNames: [],
      selectedParentAsins: [],
      selectedSellerCategories: [],
      selectedSellerCategories2: [],
      selectedSellerCategories3: [],
      selectedSellerCategories4: [],
      selectedSellerCategories5: [],
      availableDates: undefined,
      filtered: false,
      showFilters: false,
      // 表
      pageSize: 20,
      defaultColDef: {
        sortable: true,
        editable: false,
        resizable: true,
        suppressMenu: true
      },
      amcProfileCategory: '',
      columnDefs: [
        {
          headerName: '売上',
          field: 'sales'
        },
        {
          headerName: 'リピート_定期便売上',
          field: 'repeatSnSSales'
        },
        {
          headerName: 'リピート_通常売上',
          field: 'repeatGeneralSales'
        },
        {
          headerName: '新規_定期便売上',
          field: 'newSnSSales'
        },
        {
          headerName: '新規_通常売上',
          field: 'newGeneralSales'
        },
        {
          headerName: '定期便登録数',
          field: 'activeSubscription'
        },
        {
          headerName: 'リピート率',
          field: 'repeatRate'
        },
        {
          headerName: '定期便利用率',
          field: 'SnSRate'
        },
      ],
      pinnedBottomRowData: [],
      gridOptions: {},
      // APIのactionとパラメータの対応
      apiParameters: {
        summary: ['start_day', 'end_day', 'filters'],
        selectedCategory: ['start_day', 'end_day', 'filters'],
        pastYearMonthly: ['filters'],
        salesByTitle: ['start_day', 'end_day'],
        salesByAsin: ['start_day', 'end_day'],
        salesByParentAsin: ['start_day', 'end_day'],
        salesByBrand: ['start_day', 'end_day'],
        salesBySubCategoryName: ['start_day', 'end_day'],
        salesBySellerCategory: ['start_day', 'end_day'],
        salesBySellerCategory2: ['start_day', 'end_day'],
        salesBySellerCategory3: ['start_day', 'end_day'],
        salesBySellerCategory4: ['start_day', 'end_day'],
        salesBySellerCategory5: ['start_day', 'end_day']
      },
    }
  },
  computed: {
    ...mapState(['startDay', 'endDay']),
    ...mapState('amcRepeat', ['requestingStatus', 'reportData', 'filterOptions']),
    ...mapState('account', ['activeAccount']),
    salesByTitleFilterNoOptionText () {
      return this.requestingStatus.salesByTitle ? 'Loading...' : '候補がありません'
    },
    salesByAsinFilterNoOptionText () {
      return this.requestingStatus.salesByAsin ? 'Loading...' : '候補がありません'
    },
    salesByParentAsinFilterNoOptionText () {
      return this.requestingStatus.salesByParentAsin ? 'Loading...' : '候補がありません'
    },
    salesByBrandFilterNoOptionText () {
      return this.requestingStatus.salesByBrand ? 'Loading...' : '候補がありません'
    },
    salesBySubCategoryNameFilterNoOptionText () {
      return this.requestingStatus.salesBySubCategoryName ? 'Loading...' : '候補がありません'
    },
    salesBySellerCategoryFilterNoOptionText () {
      return this.requestingStatus.salesBySellerCategory ? 'Loading...' : '候補がありません'
    },
    salesBySellerCategory2FilterNoOptionText () {
      return this.requestingStatus.salesBySellerCategory2 ? 'Loading...' : '候補がありません'
    },
    salesBySellerCategory3FilterNoOptionText () {
      return this.requestingStatus.salesBySellerCategory3 ? 'Loading...' : '候補がありません'
    },
    salesBySellerCategory4FilterNoOptionText () {
      return this.requestingStatus.salesBySellerCategory4 ? 'Loading...' : '候補がありません'
    },
    salesBySellerCategory5FilterNoOptionText () {
      return this.requestingStatus.salesBySellerCategory5 ? 'Loading...' : '候補がありません'
    },
    parentAsinOptions () {
      if (!this.reportData) {
        return []
      }
      return this.reportData.salesByParentAsin.map(item => ({
        text: item.parentAsin,
        value: item.parentAsin,
        sales: item.sales
      }))
    },
    sellerCategoryOptions () {
      if (!this.reportData) {
        return []
      }
      return this.reportData.salesBySellerCategory.map(item => ({
        text: item.sellerCategory,
        value: item.sellerCategory,
        sales: item.sales
      }))
    },
    sellerCategory2Options () {
      if (!this.reportData) {
        return []
      }
      return this.reportData.salesBySellerCategory2.map(item => ({
        text: item.sellerCategory,
        value: item.sellerCategory,
        sales: item.sales
      }))
    },
    sellerCategory3Options () {
      if (!this.reportData) {
        return []
      }
      return this.reportData.salesBySellerCategory3.map(item => ({
        text: item.sellerCategory,
        value: item.sellerCategory,
        sales: item.sales
      }))
    },
    sellerCategory4Options () {
      if (!this.reportData) {
        return []
      }
      return this.reportData.salesBySellerCategory4.map(item => ({
        text: item.sellerCategory,
        value: item.sellerCategory,
        sales: item.sales
      }))
    },
    sellerCategory5Options () {
      if (!this.reportData) {
        return []
      }
      return this.reportData.salesBySellerCategory5.map(item => ({
        text: item.sellerCategory,
        value: item.sellerCategory,
        sales: item.sales
      }))
    },
    brandOptions () {
      if (!this.reportData) {
        return []
      }
      return this.reportData.salesByBrand.map(item => ({
        text: item.brand,
        value: item.brand,
        sales: item.sales
      }))
    },
    asinOptions () {
      if (!this.reportData) {
        return []
      }
      return this.reportData.salesByAsin.map(item => ({
        text: item.asin,
        value: item.asin,
        sales: item.sales
      }))
    },
    titleOptions () {
      if (!this.reportData) {
        return []
      }
      return this.reportData.salesByTitle.map(item => ({
        text: item.title,
        value: item.title,
        sales: item.sales
      }))
    },
    subCategoryNameOptions () {
      if (!this.reportData) {
        return []
      }
      return this.reportData.salesBySubCategoryName.map(item => ({
        text: item.subcategoryName,
        value: item.subcategoryName,
        sales: item.sales
      }))
    },
    selectedBrandValues () {
      return this.selectedBrands.map(selectedCategoryName => selectedCategoryName.value)
    },
    selectedAsinValues () {
      return this.selectedAsins.map(selectedAsin => selectedAsin.value)
    },
    selectedTitleValues () {
      return this.selectedTitles.map(selectedTitle => selectedTitle.value)
    },
    selectedSubCategoryNameValues () {
      return this.selectedSubCategoryNames.map(selectedSubCategoryName => selectedSubCategoryName.value)
    },
    selectedParentAsinValues () {
      return this.selectedParentAsins.map(selectedParentAsin => selectedParentAsin.value)
    },
    selectedSellerCategoryValues () {
      return this.selectedSellerCategories.map(selectedSellerCategory => selectedSellerCategory.value)
    },
    selectedSellerCategory2Values () {
      return this.selectedSellerCategories2.map(selectedSellerCategory => selectedSellerCategory.value)
    },
    selectedSellerCategory3Values () {
      return this.selectedSellerCategories3.map(selectedSellerCategory => selectedSellerCategory.value)
    },
    selectedSellerCategory4Values () {
      return this.selectedSellerCategories4.map(selectedSellerCategory => selectedSellerCategory.value)
    },
    selectedSellerCategory5Values () {
      return this.selectedSellerCategories5.map(selectedSellerCategory => selectedSellerCategory.value)
    },
    innerFiltered: {
      get () {
        return this.filtered
      },
      set (val) {
        this.filtered = val
        this.showFilters = val
      }
    }
  },
  watch: {
    selectedAsins: {
      handler () {
        this.filterReport()
      },
      deep: true
    },
    selectedTitles: {
      handler () {
        this.filterReport()
      },
      deep: true
    },
    selectedBrands: {
      handler () {
        this.filterReport()
      },
      deep: true
    },
    selectedSubCategoryNames: {
      handler () {
        this.filterReport()
      },
      deep: true
    },
    selectedParentAsins: {
      handler () {
        this.filterReport()
      },
      deep: true
    },
    selectedSellerCategories: {
      handler () {
        this.filterReport()
      },
      deep: true
    },
    selectedSellerCategories2: {
      handler () {
        this.filterReport()
      },
      deep: true
    },
    selectedSellerCategories3: {
      handler () {
        this.filterReport()
      },
      deep: true
    },
    selectedSellerCategories4: {
      handler () {
        this.filterReport()
      },
      deep: true
    },
    selectedSellerCategories5: {
      handler () {
        this.filterReport()
      },
      deep: true
    },
    activeAccount: {
      handler () {
        this.resetFilters()
      }
    }
  },
  created () {
    // 先月を指定
    this.$store.commit('SET_STARTDAY', moment().subtract(1, 'month').startOf('month').format())
    this.$store.commit('SET_ENDDAY',  moment().subtract(1, 'month').endOf('month').format())
  },
  methods: {
    ...mapActions('amcRepeat', ['fetchReport', 'downloadCSV']),
    resetFilters () {
      this.selectedAsins = []
      this.selectedTitles = []
      this.selectedBrands = []
      this.selectedSubCategoryNames = []
      this.selectedParentAsins = []
      this.selectedSellerCategories = []
      this.selectedSellerCategories2 = []
      this.selectedSellerCategories3 = []
      this.selectedSellerCategories4 = []
      this.selectedSellerCategories5 = []
    },
    onDateChange (date) {
      this.$store.commit('SET_STARTDAY', moment(date.start).format())
      this.$store.commit('SET_ENDDAY',  moment(date.end).format())
      this.currentPage = 1
      this.getReport()
    },
    onUpdateCurrentPage (val) {
      this.currentPage = val
      this.getReport()
    },
    onUpdatePaginationPageSize (val) {
      this.currentPage = 1
      this.pageSize = val
      this.getReport()
    },
    onSortChange (e) {
      const sortModel = e.columnApi.getColumnState().find(s => s.sort != null)
      if (sortModel) {
        const sortParam = `${sortModel.colId}-${sortModel.sort}`
        if (this.sortParam !== sortParam) {
          this.currentPage = 1
        }
        this.sortParam = sortParam
        this.getReport()
      }
    },
    getRowStyle (params) {
      if (params.node.rowPinned) {
        return { fontWeight: "bold" };
      }
    },
    addColumnDef () {
      if(this.reportData.selectedCategory && this.reportData.selectedCategory.length > 0) {
        const fieldNames = this.columnDefs.map(column => column.field);
        this.amcProfileCategory = Object.keys(this.reportData.selectedCategory[0]).filter(key => !fieldNames.includes(key))[0] // APIレスポンスのkeyをフィルターし、AMCプロフィールの設定値を見つける
        const headerJp = {
          brand: 'ブランド',
          sellerCategory: '出品者カテゴリー1',
          sellerCategory2: '出品者カテゴリー2',
          sellerCategory3: '出品者カテゴリー3',
          sellerCategory4: '出品者カテゴリー4',
          sellerCategory5: '出品者カテゴリー5'
        }
        this.columnDefs.push({
          headerName: headerJp[this.amcProfileCategory],
          field: this.amcProfileCategory,
          pinned: 'left'
        })
      }
    },
    generateParams (paramKeys) {
      const params = {}
      if ( paramKeys.includes('start_day') && paramKeys.includes('end_day') ) {
        params['start_day'] = this.startDay.split('T')[0]
        params['end_day'] = this.endDay.split('T')[0]
      }
      if ( paramKeys.includes('filters') ) {
        if (this.selectedAsinValues) {
          params['asin'] = this.selectedAsinValues
        }
        if (this.selectedTitleValues) {
          params['title'] = this.selectedTitleValues
        }
        if (this.selectedBrandValues) {
          params['brand'] = this.selectedBrandValues
        }
        if (this.selectedSubCategoryNameValues) {
          params['subcategory_name'] = this.selectedSubCategoryNameValues
        }
        if (this.selectedParentAsinValues) {
          params['parent_asin'] = this.selectedParentAsinValues
        }
        if (this.selectedSellerCategoryValues) {
          params['seller_category'] = this.selectedSellerCategoryValues
        }
        if (this.selectedSellerCategory2Values) {
          params['seller_category2'] = this.selectedSellerCategory2Values
        }
        if (this.selectedSellerCategory3Values) {
          params['seller_category3'] = this.selectedSellerCategory3Values
        }
        if (this.selectedSellerCategory4Values) {
          params['seller_category4'] = this.selectedSellerCategory4Values
        }
        if (this.selectedSellerCategory5Values) {
          params['seller_category5'] = this.selectedSellerCategory5Values
        }
      }
      return params
    },
    async onClickDownload (action) {
      try {
        await this.downloadCSV(this.generateParams(this.apiParameters[action]))
      } catch (e) {
        console.log(e)
      }
    },
    filterReport: debounce(function () {
      this.getReport()
    }, 1000),
    async getReport () { 
      const actions = [
        'summary',
        'selectedCategory',
        'pastYearMonthly',
        'salesByTitle',
        'salesByAsin',
        'salesByParentAsin',
        'salesByBrand',
        'salesBySubCategoryName',
        'salesBySellerCategory',
        'salesBySellerCategory2',
        'salesBySellerCategory3',
        'salesBySellerCategory4',
        'salesBySellerCategory5',
      ]

      await Promise.all(actions.map(action => {
        return new Promise((resolve) => {
          try {
            resolve(this.fetchReport({
              ...this.generateParams(this.apiParameters[action]),
              action
            }))
          } catch (e) {
            console.log(e)
          }
        })
      }))
      if(this.reportData?.summary) {
        // サマリーを表の総計用に加工
        const bottomRow = structuredClone(this.reportData?.summary)
        bottomRow.brand = '総計'
        this.pinnedBottomRowData = [bottomRow]
      }
      if(this.amcProfileCategory === '') {
        // AMCプロフィールのカテゴリー設定を見て動的カラム追加
        this.addColumnDef()
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.page_content--loading .vx-card {
  min-height: 127.875px;
}
</style>

<style>
.holamundo :deep(.vs-popup) {
  width: 400px;
}
div.filter {
    display: flex;
    flex-wrap: wrap;
}
.sales-filter .multiselect__tags,
.sales-filter .multiselect__tags .multiselect__input,
.sales-filter .multiselect__content-wrapper {
  font-size: 13px;
}
</style>
